<template>
  <div>
    <el-scrollbar
      wrapStyle="overflow-x:hidden;"
      :style="`height:${scroll_height}px`"
    >
      <div class="l-supplier" :style="`width:${width}px`">
        <el-tree
          :data="classList"
          render-after-expand
          node-key="class_no"
          default-expand-all
          :check-on-click-node="false"
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>
              <span style="color:#409eff">{{ node.key }}</span>
              {{ node.label
              }}<span
                v-if="data.describe && btnshow"
                class="custom-tree-describe"
                >（{{ data.describe }}）</span
              >
            </span>
            <span v-if="btnshow">
              <el-button type="text" @click="() => systemReturn(data.class_no)">
                修改
              </el-button>
              <el-button
                type="text"
                style="color:#F56C6C"
                @click="() => remove(data)"
              >
                删除
              </el-button>
            </span>
            <!-- <span v-else>
                <span v-if="data.describe" class="custom-tree-describe">（{{ data.describe }}）</span>
              </span> -->
          </span>
        </el-tree>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
import { classifyList } from "@/api/merchant.js";
import { queryOfflineClassify } from "@/api/offlinestores.js";
export default {
  name: "dyhonlineclass",
  watch: {
    innerWH: {
      handler(newinner, oldinner) {
        if (newinner.innerHeight < 700) {
          this.scroll_height = newinner.innerHeight - 160;
        } else {
          this.scroll_height = newinner.innerHeight - 190;
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  props: {
    btnshow: {
      default: true,
      type: Boolean
    },
    width: {
      default: 450,
      type: Number
    },
    who: {
      default: "online",
      type: String
    }
  },
  data() {
    return {
      classList: [],
      allClassList: [],
      scroll_height: ""
    };
  },
  mounted() {
    this.getClassifyList();
  },
  methods: {
    systemReturn(res) {
      this.$emit("systemReturn", res);
    },
    remove(res) {
      this.$emit("remove", res);
    },
    async getClassifyList() {
      this.classList = [];
      this.classofflinelist = [];
      this.allClassList = [];
      var res = {};
      if (this.who === "online") {
        res = await classifyList();
        this.allClassList = res;

        var t2 = [];
        var t4 = [];
        var t6 = [];
        for (let i = 0; i < res.length; i++) {
          if (
            res[i].class_no.trim().length === 2 &&
            res[i].parent_class_no === "0"
          ) {
            t2.push({
              class_no: res[i].class_no,
              label: res[i].class_name,
              parent_class_no: res[i].parent_class_no,
              describe: res[i].describe,
              children: []
            });
          }
          if (res[i].class_no.trim().length === 4) {
            t4.push({
              class_no: res[i].class_no,
              label: res[i].class_name,
              parent_class_no: res[i].parent_class_no,
              describe: res[i].describe,
              children: []
            });
          }
          if (res[i].class_no.trim().length === 6) {
            t6.push({
              class_no: res[i].class_no,
              label: res[i].class_name,
              describe: res[i].describe,
              parent_class_no: res[i].parent_class_no
            });
          }
        }
        for (let i = 0; i < t6.length; i++) {
          for (let j = 0; j < t4.length; j++) {
            if (t6[i].parent_class_no === t4[j].class_no) {
              t4[j].children.push(t6[i]);
            }
          }
        }

        for (let i = 0; i < t4.length; i++) {
          for (let j = 0; j < t2.length; j++) {
            if (t4[i].parent_class_no === t2[j].class_no) {
              t2[j].children.push(t4[i]);
            }
          }
        }

        this.classList = t2;
      } else if (this.who === "offline") {
        /* eslint-disable */
        this.allClassList = res;
        var t2 = [];
        var t4 = [];
        var t6 = [];
        res = await queryOfflineClassify();
        for (let i = 0; i < res.length; i++) {
          if (
            res[i].class_no.trim().length == 2
          ) {
            t2.push({
              class_no: res[i].class_no,
              label: res[i].class_name,
              children: []
            });
          }
          if (res[i].class_no.trim().length == 4) {
            t4.push({
              class_no: res[i].class_no,
              label: res[i].class_name,
              children: []
            });
          }
          if (res[i].class_no.trim().length == 6) {
            t6.push({
              class_no: res[i].class_no,
              label: res[i].class_name
            });
          }
        }
        for (let i = 0; i < t6.length; i++) {
          for (let j = 0; j < t4.length; j++) {
            if (t6[i].class_no.slice(0, 4) == t4[j].class_no.trim()) {
              t4[j].children.push(t6[i]);
            }
          }
        }

        for (let i = 0; i < t4.length; i++) {
          for (let j = 0; j < t2.length; j++) {
            if (t4[i].class_no.slice(0, 2) == t2[j].class_no.trim()) {
              t2[j].children.push(t4[i]);
            }
          }
        }
        this.classList = t2;
      }
    }
  }
};
</script>
<style scoped>
.l-supplier {
  padding-right: 15px;
  overflow: hidden;
}

.custom-tree-describe {
  width: 150px;
  font-size: 10px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
